<template>
    <div class="mi-work-order" >
        <div>
            <el-tooltip :disabled="disabled" placement="top" effect="dark">
                <div slot="content" style="max-width: 250px;">{{params.material_name }}</div>
                <h5 
                    :style="{width: params.is_used==='1'? '100px': '130px' }" 
                    class="item-title mi-work-order-title ellipsis"  
                    ref="ellipsis_box"
                    :class="params.is_used ==='1' ? 'ml30 isUse' : ''"
                >
                    {{  params.material_name }}
                </h5>
            </el-tooltip>
            <div v-if="params.is_used ==='1'" class="icon-use"><svg-icon icon-class="use"/></div>
            <div class="item-view" >
                <img class="item-view-img"
                     :src="show_img"
                     v-on:load="imageLoaded"
                     v-on:error="imageFailed"
                />
                <div class="mask" :class="[params.is_used ==='1' ? 'isUse' : '']">
                    <div style="display: flex;">
                        <div>
                            <el-popover @show="()=>showContent= true" placement="left" width="440" trigger="click"
                                        ref="mipop">
                                <div class="mi-pop-content">
                                    <div>
                                        <img class="mi-material" :src="params.full_material_url" v-if="params.material_type == 1"/>
                                        <video class="mi-material mi-popver-video item-view-video item-view-video-addlistnter"
                                               :poster="params.img_full_material_url"
                                               :src="params.full_material_url" controls  preload="metadata" v-else-if="params.material_type == 3&&showContent"></video>
                                    </div>
                                </div>
                                <el-button size="mini" type="text"  slot="reference">预览</el-button>
                            </el-popover>
                        </div>
                        <div class="add-suc"
                             :class="{ active: active, 'no-transition': !active }">
                            >
                            <el-button size="mini" type="text" style="margin-left: 8px;"
                                       @click="handleAdd">
                                添加</el-button>
                            <el-tag type="success" class="suc-tips">成功 +1</el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-footer" :class="[params.is_used ==='1' ? 'isUse' : '']">
                <span class="sizes">{{params.material_size}}</span>
                <span class="times"
                      v-if="params.material_type == 3">{{ params.material_duration }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {ellipseShowPromise} from '@/utils'
import noImg from '@/assets/img/mi-no-img.png'
import { debounce } from 'lodash'
import SvgIcon from '@/components/SvgIcon'
export default {
    name: 'mi-work-order',
    components: {
        SvgIcon
    },
    props:{
        params: {
            type: Object,
            default: function() {
                return {
                    material_name: '',
                    material_type: 1,
                    full_material_url: '',
                    material_url: '',
                    img_material_url: '',
                    img_full_material_url: '',
                    material_size: '',
                    material_duration: ''
                }
            }
        }
    },
    data() {
        return {
            active: false,
            no_img: noImg,
            show_img: '',
            is_fail: false,  // 图片是否开裂
            disabled: true,
            showPopper: false,
            showContent: false
        }
    },
    // created() {
    //     this.show_img = this.params.img_full_material_url
    // },
    watch: {
        'params': {
            handler() {
                this.show_img = this.params.img_full_material_url ? this.params.img_full_material_url : ''
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.setDisabled()
    },
    methods: {
        handleVideoPause() {},
        handleAdd() {
            this.$emit('add')
        },
        imageLoaded() {
        },
        imageFailed() {
            this.is_fail = true
            this.show_img = this.no_img
        },
        setDisabled(){
            let curEle = this.$refs.ellipsis_box
            ellipseShowPromise(curEle).then(hasEllipsis => {
                if (hasEllipsis) {
                    this.disabled = false
                } else {
                    this.disabled = true
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.isUse { 
    filter: grayscale(100%); /* 灰度滤镜 */
    color: gray;
}
.mi-work-order {
    padding: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid #DCDFE6;
    flex: 0 1 150px;
    max-width: 150px;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    .icon-use {
        position: absolute;
        top: 0;
        font-size: 30px;
        z-index: 99;
    }

    .item-title {
        padding: 0;
        margin-bottom: 8px;
        border: none;
        font-weight: normal;
        font-size: 12px;
    }

    .item-view {
        position: relative;
        margin-bottom: 8px;
        cursor: pointer;
        width: 130px;
        height: 80px;
        display: flex;

        .item-view-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            border: 1px solid #DCDFE6;

        }

        .item-view-video {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            border: 1px solid #DCDFE6;
        }

        .mask {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            justify-content: center;
            align-items: center;
            .el-button--mini {
                color: #fff;
            }
        }

        &:hover {
            .mask {
                display: flex;
            }
        }

        .add-suc {
            position: relative;

            .suc-tips {
                position: absolute;
                top: -20px;
                left: 6px;
                opacity: 0;
                transition: all 0.3s ease;
                /* 添加动画效果 */
            }

            &.active {
                .suc-tips {
                    opacity: 1;
                    top: -30px;
                }
            }

            &.no-transition {
                transition: none;
                /* 移除过渡效果 */
            }
        }
    }

    .item-footer {
        .sizes {
            font-size: 12px;
            padding-right: 24px;
        }

        .times {
            font-size: 12px;
        }
    }
}

</style>
<style lang="scss">
.mi-pop-content {
    display: flex;
    justify-content: center;

    .mi-material {
        max-height: 320px;
        width: 100%;
        object-fit: contain;
        object-position: center;
    }
}
</style>
